import Vue from 'vue'
//import Cookie from 'vue-cookie'
//Vue.use(Cookie)

export default {
    changeUser(context, payload){
        context.commit('SET_USER', payload)
    },
    changeAuth(context, payload){
        context.commit('SET_AUTH', payload)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js